import { Location } from "gen/company/models_pb"

import { useAppDispatch, useAppSelector } from "app/hooks"
import { LocationCombobox } from "components/composite/input"

import { selectLocationWithoutDefault, setLocation } from "./authSlice"
import { useGetCompanyForCurrentSubdomain } from "./useGetCompanyForCurrentSubdomain"

export function SignInLocationCombobox() {
  const { currentData: company } = useGetCompanyForCurrentSubdomain()
  const locations = company?.locations.filter((loc) => loc.isActive) ?? []

  const selectedLocation = useAppSelector(selectLocationWithoutDefault)

  const dispatch = useAppDispatch()

  function onSelectItem(item: Location | null) {
    dispatch(setLocation(item))
  }

  return (
    <LocationCombobox
      label="Location"
      placeholder="Select a location"
      locations={locations}
      selectedItem={selectedLocation}
      onSelectItem={onSelectItem}
      className="w-full"
      isOpenOnFocus
    />
  )
}
